import { createContext } from 'react';

export const RouteContext = createContext({});

export const RouteProvider = RouteContext.Provider;
export const RouteConsumer = RouteContext.Consumer;
